import {merge} from '#core/utils/config-utils.js';

import {BasePalette} from '#core/application/modules/base-palette.js';
import {generateSkeletonPart} from '#core/application/modules/tiles/skeleton-part/index.js';
import {generateToggleButtonRow} from '#core/application/modules/tiles/button/toggle-button/index.js';
import {generateSportFilterCircleRow} from '#core/application/modules/tiles/sport-filter-circle-button/index.js';

export function inPlayPageFactory(PALETTE) {
    return {
        InPlayMenu: {
            rootContainer: {
                style: {
                    fontFamily: BasePalette.palette.FONT_FAMILY,
                    padding: '8px 0',
                    _mobile_padding: '8px 8px 0 8px',
                },
            },
            navigationMenu: BasePalette.isAvantgarde()
                ? merge(generateSportFilterCircleRow(PALETTE.INPLAY_SPORTS_FILTER_CIRCLE_BUTTON), {
                      showItemLabel: false,
                      showSelectedItemLabel: false,
                  })
                : generateToggleButtonRow(PALETTE.INPLAY_SPORTS_SELECTOR),
            navigationMenuSkeleton: {
                linkPlaceholder: generateSkeletonPart(PALETTE.INPLAY_SPORTS_SELECTOR_SKELETON_PART),
            },
        },
    };
}
